import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import DiscountContent from './DiscountContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function DiscountContainer({
  match,
  history,
  getDiscountList,
  discountList,
  isLoading,
  removeDiscount,
  discountListPager,
  getSingleDiscount,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Discount',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Discount',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Discount?',
      () => {
        removeDiscount(data.id, () => {
          getDiscountList();
          const id = _.get(discountList, '0.id');
          history.push(`${id}`);
          getSingleDiscount(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getDiscountList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getDiscountList({ q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:discountId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Discount"
            getData={getDiscountList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:discountId?`}
            listName="discounts"
            label="Discounts"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.name')}</div>
            )}
            isLoading={isLoading}
            selected={params.discountId}
            data={discountList}
            dataPager={discountListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:discountId?`}
                    render={() => (
                      <DiscountContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:discountId?`}
                  render={() =>
                    !params.discountId && discountList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(discountList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

DiscountContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getDiscountList: PropTypes.instanceOf(Function).isRequired,
  discountList: PropTypes.instanceOf(Array).isRequired,
  discountListPager: PropTypes.instanceOf(Object).isRequired,
  removeDiscount: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleDiscount: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  discountList: _.get(api, `${c.GET_DISCOUNT}.list`) || [],
  discountListPager: _.get(api, `${c.GET_DISCOUNT}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_DISCOUNT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DiscountContainer);
